<div class="warp-steps" [ngClass]="{'isPreview':isPreview}" #dd>
    <div class="details" *ngIf="isUser$() || statusNotEdit$()">
        <img class="scale-img" src="/assets/images/definitions/back.svg" (click)="goToMyQuestionnaire()">
        <div (click)="goToMyQuestionnaire()">
            <p class="name none-in-mobile pointer" translate>steps.toAllQuestionnaire</p>
        </div>
    </div>

    <div class="details pointer" *ngIf="!isUser$()&&isPreview && !statusNotEdit$()" (click)="back()">
        <img class="scale-img" src="/assets/images/definitions/back.svg">
        <div>
            <p class="name" translate>steps.preview</p>
        </div>
    </div>
    <div class="end">
        <que-answer-questionnarie-lower-nav *ngIf="isUser$()"></que-answer-questionnarie-lower-nav>
        <div class="logged-user" *ngIf="isUser$()&&isPreview">
            <que-logged-user [isPreview]="isPreview"></que-logged-user>
        </div>
    </div>
</div>

<ng-template #loadingSave>
    <div class="load-save">
        <p translate>saveLoading</p>
        <img class="load-img" src="/assets/images/loading/save-loading.svg">
    </div>
</ng-template>